import React from "react";
import { formatCurrency, type CurrencyFormatOptions } from "../../../tools/U2000CurrencyUtils";

interface U2000CurrencyDisplayProps {
  value: number | string | null | undefined;
  align?: "left" | "center" | "right";
  options?: CurrencyFormatOptions;
}

export const U2000CurrencyDisplay: React.FC<U2000CurrencyDisplayProps> = ({ value, align = "right", options = {} }) => {
  if (value === null || value === undefined) {
    return <span className="text-gray-400">—</span>;
  }

  const formatted = formatCurrency(value, {
    currencySymbol: "$",
    decimalDigits: 2,
    ...options,
  });

  const alignClass = align === "left" ? "text-left" : align === "center" ? "text-center" : "text-right";

  return <span className={`${alignClass} block`}>{formatted}</span>;
};

export default U2000CurrencyDisplay;
